import { Modal, Button, Form, Col, Row, Container, FormCheck  } from 'react-bootstrap';
import { useState, useRef, useEffect } from 'react';
import { useSelector,useDispatch } from "react-redux";
import '../../assets/Styles/CancelTripCSS/CancelTripCSS.css';
// import ConfirmationModal from '../Controls/ConfirmationModal';
import APICom from '../../utils/helpers/APICom';
import moment from 'moment';
import { SetARBResponsePersistData } from '../../features/common/ARBSlice.js';
import _ from 'lodash';

const AddBreakModal = (props) => {
  const { loginData } = useSelector((store) => store.login);
  const [startTime, setStartTime] = useState('');
  const [earlyWindow, setEarlyWindow] = useState('');
  const [breakDuration, setBreakDuration] = useState('');
  const [lateWindow, setLateWindow] = useState('');
  const xCancelSourceForGrid = useRef(null);
  const dispatch = useDispatch();
  // setStartTime(props.showAddBreakModal.starttime);
  var TempBreaks = 0;
  const handleSaveChanges = async () => {
    let finalData = {};
    
    try{
      var start_time = document.getElementById("startTime").value;
      let array = props.showAddBreakModal.selectedRow;
      let PUarray = _.cloneDeep(array);
      let dat = new Date(PUarray.ReqTimeHidden);
      let year = dat.getFullYear();
      let month = dat.getMonth();
      let day = dat.getDate();

      let getMinutes = 0;
      let getHour = 0;
      try {
          getMinutes = start_time.split(':')[1];
          getHour = start_time.split(':')[0];
      } catch { }

      let getSeconds = start_time.split(':')[2];
      try {
          if (typeof start_time.split(':')[2] == 'undefined') {
              getSeconds = 0;
          }
          else {
              getSeconds = start_time.split(':')[2];
          }
      } catch { }

      let end_time = new Date(year, month, day, getHour, parseInt(getMinutes) + parseInt(breakDuration), getSeconds);
      const hours = end_time.getHours().toString().padStart(2, '0');
      const minutes = end_time.getMinutes().toString().padStart(2, '0');
      const formattedTime = `${hours}:${minutes}`;
      end_time = formattedTime;
      TempBreaks++;
      let break_stop_no = PUarray["Stop#"];
      var BreakID = 'BRK' + TempBreaks.toString();
      PUarray.PUPerson = 'BreakTrip';
      PUarray.ReqTime = "";
      PUarray.SchTime = end_time;
      PUarray.dEstimatedTime = parseInt(breakDuration);
      PUarray.dLateTimeWindow = parseInt(lateWindow);
      PUarray.dEarlyTimeWindow = parseInt(earlyWindow);
      PUarray.Index = BreakID + '_DO';
      PUarray.Type = 'DO';
      PUarray["Stop#"] = break_stop_no + 1
      PUarray["iVehStopOrder"] = break_stop_no + 1
      //PUarray.SaveStatus = 1;
      PUarray.Actions = "";
      //copy_data["Confirmation #"] = BreakID;
      PUarray["StylCondDev"] = 'BreakTrip';
      let StopViewMainData =props.showAddBreakModal.tableData;
      var JobID = ServiceStop(PUarray["TripNo"], StopViewMainData);
      try { JobID = JobID.split('_')[0]; } catch { }
      let dat1 = new Date(PUarray["ReqTimeHidden"]);
      let year1 = dat1.getFullYear();
      let month1= dat1.getMonth() + 1;
      let day1 = dat1.getDate();
      let _timePart = militaryToNormal(end_time);

      PUarray.ReqTimeHidden = PUarray.ReqTimeHidden.split('T')[0] + ' ' + _timePart ;

      let _schPUTime = moment(month1 + "/" + day1 + "/" + year1 + " " + start_time);
      let _schDOTime = moment(month1 + "/" + day1 + "/" + year1 + " " + end_time);
      let _startTime = moment(month1 + "/" + day1 + "/" + year1 + " " + start_time);
      
      var _objT = {
        "PUStopNumber": parseInt(break_stop_no),
        "DOStopNumber": parseInt(break_stop_no + 1),
        "Route": PUarray.Route,
        "AssignedVehID": parseInt(PUarray["iVehicleID"]),
        "SchPUTime": _schPUTime._i,
        "SchDOTime": _schDOTime._i,
        "JobID": JobID,
        "RefID": "-1",
        "StartTime": _startTime._i,
        "Duration": parseFloat(breakDuration),
        "ManifestDisposition": "BRASA",
        "CreatedByUserID":loginData.iUserID,
        "EarlyStartWindow": parseFloat(earlyWindow),
        "LateStartWindow": parseFloat(lateWindow)
    };
    
      let DOarray = _.cloneDeep(PUarray);
      finalData["PUarray"] = PUarray;
      finalData["input"] = _objT;
      let NextServiceTrip = -1
      NextServiceTrip = NextServiceStop(PUarray["TripNo"], StopViewMainData);

      finalData["NextServiceTrip"] = NextServiceTrip;
      DOarray.Index = BreakID + '_PU';
      DOarray.Type = 'PU';
      DOarray["Stop#"] = break_stop_no;
      DOarray["iVehStopOrder"] = break_stop_no;
      DOarray.SchTime = start_time;
      DOarray.ReqTime = start_time;
      finalData["DOarray"] = DOarray;

      dispatch(SetARBResponsePersistData({data: finalData, name:"StopViewBreakTrip"}));
  }
  catch(err){console.log(err);}
  };

  const handleCancel = () => {
    setStartTime('');
    setEarlyWindow('');
    setBreakDuration('');
    setLateWindow('');
  };
  const NextServiceStop = (conf , _result)=>{
    var index = _result.findIndex(trip => trip["TripNo"] == conf);
    let j = index;
    var serviceTrip = -1;
    while (j < _result.length) {
      var _StopType = _result[j].Type;
      var _PUPerson = _result[j].PUPerson;
      var ConfirmationNo = _result[j].TripNo;
      if ((ConfirmationNo !=conf) && (_StopType.toLowerCase() == 'pu' || _StopType.toLowerCase() == 'enddept') && (_StopType.toLowerCase() != 'idletime')) {
          serviceTrip = _result[j]["Index"];
          break;
      }
      j++;
    }
    return serviceTrip;
  }
  const  ServiceStop = (conf, _result)=> {
    var index = _result.findIndex(trip => trip["TripNo"] == conf);
    let i = index, j = index;
    var serviceTrip = -1;
    var bServiceTripFound = false;
    while (i > 0) {
        var _StopType = _result[i].Type;
        var _PUPerson = _result[i].PUPerson;
        if ((_StopType.toLowerCase() == 'pu' || _StopType.toLowerCase() == 'do') && _PUPerson.toLowerCase() != 'breaktrip' && _StopType.toLowerCase() != 'idletime' && _StopType.toLowerCase() != 'startdept') {
            serviceTrip = _result[i]["Index"];
            bServiceTripFound = true;
            break;
        }
        i--;
    }
    if (!bServiceTripFound) {
        while (j < _result.length) {
            var _StopType = _result[j].Type;
            var _PUPerson = _result[j].PUPerson;
            if ((_StopType.toLowerCase() == 'pu' || _StopType.toLowerCase() == 'do') && _PUPerson.toLowerCase() != 'breaktrip' && (_StopType.toLowerCase() != 'idletime' || _StopType.toLowerCase() != 'enddept')) {
                serviceTrip = _result[j]["Index"];
                bServiceTripFound = true;
                break;
            }
            j++;
        }
    }
    return serviceTrip;
}

  const militaryToNormal = (str) => {
    var h1 = Number(str[0] - '0');
    var h2 = Number(str[1] - '0');
    var hh = h1 * 10 + h2;
    var Meridien;
    var time = "";
    if (hh < 12) {
        Meridien = "AM";
    }
    else
        Meridien = "PM";

    hh %= 12;
    if (hh == 0) {
        time += "12";

        for (var i = 2; i < 5; ++i) {
            time += str[i];
        }
    }
    else {
        time += hh;
        for (var i = 2; i < 5; ++i) {
            time += str[i];
        }
    }
    return (time += " " + Meridien);
}
  return (
    <>
      <Modal show={props.showAddBreakModal.isVisible ? 1 : 0} centered backdrop="static" animation={true} onHide={() => {props.setAddBreakModal(false)}} keyboard={true} size="md" aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
          <Modal.Title className='dispatch_action_dialog_title_color user-select-none'>
            Break Trip Input
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          <div className="form-row d-flex justify-content-between">
            <div className="form-group col-md-5">
              <label htmlFor="startTime">Start Time</label>
              <input type="time" className="form-control" id="startTime" value={props.showAddBreakModal.starttime} onChange={(e) => setStartTime(e.target.value)}/>
            </div>
            <div className="form-group col-md-5">
              <label htmlFor="earlyWindow">Early Window</label>
              <input type="text" className="form-control" id="earlyWindow" value={earlyWindow} onChange={(e) => setEarlyWindow(e.target.value)}/>
            </div>
          </div>
          <div className="form-row d-flex justify-content-between">
            <div className="form-group col-md-5">
              <label htmlFor="breakDuration">Break Duration</label>
              <input type="text" className="form-control" id="breakDuration" value={breakDuration} onChange={(e) => setBreakDuration(e.target.value)}/>
            </div>
            <div className="form-group col-md-5">
              <label htmlFor="lateWindow">Late Window</label>
              <input type="text" className="form-control" id="lateWindow" value={lateWindow} onChange={(e) => setLateWindow(e.target.value)}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="activate_btn_ok border-0" onClick={handleSaveChanges}>Save Changes</Button>
          <Button className="activate_btn_ok border-0" onClick={() => {props.setAddBreakModal(false)}}>Cancel</Button>
        </Modal.Footer>
      </Modal>


    </>
    
    // isOpen && (
    //   <div className="modal-overlay">
    //     <div className="modal">
    //       <h2>Break Input Trip</h2>
    //       <label>
    //         Start Time:
    //         <input type="text" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
    //       </label>
    //       <label>
    //         Early Window:
    //         <input type="text" value={earlyWindow} onChange={(e) => setEarlyWindow(e.target.value)} />
    //       </label>
    //       <label>
    //         Break Duration:
    //         <input type="text" value={breakDuration} onChange={(e) => setBreakDuration(e.target.value)} />
    //       </label>
    //       <label>
    //         Late Window:
    //         <input type="text" value={lateWindow} onChange={(e) => setLateWindow(e.target.value)} />
    //       </label>
    //       <div className="button-container">
    //         <button onClick={handleSaveChanges}>Save Changes</button>
    //         <button onClick={handleCancel}>Cancel</button>
    //       </div>
    //     </div>
    //   </div>
    //)
  );
};

export default AddBreakModal;
